var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardDeviceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 9.08329V3.41663C17.9167 2.16663 17.3834 1.66663 16.0584 1.66663H12.6917C11.3667 1.66663 10.8334 2.16663 10.8334 3.41663V9.08329C10.8334 10.3333 11.3667 10.8333 12.6917 10.8333H16.0584C17.3834 10.8333 17.9167 10.3333 17.9167 9.08329Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16671 10.9166V16.5833C9.16671 17.8333 8.63337 18.3333 7.30837 18.3333H3.94171C2.61671 18.3333 2.08337 17.8333 2.08337 16.5833V10.9166C2.08337 9.66663 2.61671 9.16663 3.94171 9.16663H7.30837C8.63337 9.16663 9.16671 9.66663 9.16671 10.9166Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 16.5833V14.25C17.9167 13 17.3834 12.5 16.0584 12.5H12.6917C11.3667 12.5 10.8334 13 10.8334 14.25V16.5833C10.8334 17.8333 11.3667 18.3333 12.6917 18.3333H16.0584C17.3834 18.3333 17.9167 17.8333 17.9167 16.5833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16671 5.74996V3.41663C9.16671 2.16663 8.63337 1.66663 7.30837 1.66663H3.94171C2.61671 1.66663 2.08337 2.16663 2.08337 3.41663V5.74996C2.08337 6.99996 2.61671 7.49996 3.94171 7.49996H7.30837C8.63337 7.49996 9.16671 6.99996 9.16671 5.74996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDeviceActive);
export default __webpack_public_path__ + "static/media/dashboard-device-active.ed3d3fd3836f9085632423e348325101.svg";
export { ForwardRef as ReactComponent };